import { render, staticRenderFns } from "./Apopoints.vue?vue&type=template&id=42845738&scoped=true"
import script from "./Apopoints.vue?vue&type=script&lang=js"
export * from "./Apopoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42845738",
  null
  
)

export default component.exports